import React, { useState } from 'react';
import { Form, Row, Col, InputGroup, OverlayTrigger, Popover } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom';
import { useTranslation } from 'react-i18next';
import { MonthPicker } from '@rd-web-markets/shared/dist/util/date';
import BusinessUnitsSection from './BusinessUnitsSection';
import { fields_of_science_and_technology } from './fields_of_science_and_technology';
import ThemeSection from './ThemeSection';
import { SHOULD_SHOW_DATE_IN_SUMMARY_SECTION } from '@rd-web-markets/market/dist/constants';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import Select, { createFilter } from 'react-select';
import ImmutableUnderReviewFormControl from '../util/reviewEditControls/ImmutableUnderReviewFormControl';
import ImmutableUnderReviewFormCheck from '../util/reviewEditControls/ImmutableUnderReviewFormCheck';
import ChangeHighlightedImmutableUnderReviewControl from '../util/reviewEditControls/ChangeHighlightedImmutableUnderReviewControl';
import ImmutableUnderReviewSelect from '../util/reviewEditControls/ImmutableUnderReviewSelect';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { useDispatch, useSelector } from 'react-redux';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { claimProjectOverviewNoteService } from '@rd-web-markets/shared/dist/services/claim_project_overview/claim_project_overview_notes.service';
import { useGetUserClaimGroupAbilities } from '../util/userAbilities';
const SummarySection = _ref => {
  let {
    handleChange,
    report,
    company,
    toggleOngoing,
    isOngoing,
    setReport,
    claimGroup,
    handleSubmit,
    handleDateChange,
    pageAccess
  } = _ref;
  const {
    t
  } = useTranslation();
  const [comment, setComment] = useState('');
  const [showCommentPopup, setShowCommentPopup] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const sortByLabel = list => {
    return list.sort((elA, elB) => {
      if (elA.label > elB.label) return 1;else if (elA.label < elB.label) return -1;
      return 0;
    });
  };
  const postComment = async () => {
    try {
      const response = await claimProjectOverviewNoteService.create(report.id, {
        note: comment
      });
      report.report_notes.push(response);
      setReport({
        ...report
      });
      setComment('');
      setShowCommentPopup(true);
    } catch (e) {
      dispatch(handleError(e));
    }
  };
  const popover = /*#__PURE__*/React.createElement(Popover, {
    id: "popover-basic"
  }, /*#__PURE__*/React.createElement(Popover.Body, null, "You comments has been saved to the 'Comments' tab, to view it please click on the below link", /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Link, {
    to: `${location.pathname}?key=notes`
  }, "Link to Comment")), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    onClick: () => setShowCommentPopup(false)
  }, t('close')))));
  return /*#__PURE__*/React.createElement(React.Fragment, null, SHOULD_SHOW_DATE_IN_SUMMARY_SECTION && /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('rnd_project_dates')), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(InputGroup, {
    style: {
      'flex-wrap': 'nowrap'
    }
  }, /*#__PURE__*/React.createElement(Col, {
    md: 4,
    className: "p-0"
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    disabled: !pageAccess.canEditProjectDetails,
    as: MonthPicker,
    selected: report.rnd_start_date,
    onChange: date => handleDateChange({
      target: {
        name: 'rnd_start_date',
        value: date
      }
    })
  })), !isOngoing && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, {
    md: 1,
    className: "p-0 ms-2 me-2"
  }, /*#__PURE__*/React.createElement(InputGroup.Text, null, t('to'))), /*#__PURE__*/React.createElement(Col, {
    md: 4,
    className: "p-0"
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    disabled: !pageAccess.canEditProjectDetails,
    onBlur: handleSubmit,
    as: MonthPicker,
    selected: report.rnd_end_date,
    onChange: date => handleDateChange({
      target: {
        name: 'rnd_end_date',
        value: date
      }
    })
  }))), /*#__PURE__*/React.createElement(Col, {
    md: 3,
    className: "p-1"
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormCheck, {
    disabled: !pageAccess.canEditProjectDetails,
    checked: isOngoing,
    onBlur: handleSubmit,
    label: t('ongoing'),
    onChange: e => toggleOngoing(e)
  }))))), process.env.PUBLIC_URL === '/uk' && company?.has_subsidiary_companies && /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('select_subsidiary_company')), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    disabled: !pageAccess.canEditProjectDetails,
    as: "select",
    name: "subsidiary_company_id",
    onBlur: handleSubmit,
    onChange: handleChange,
    size: "md",
    value: report.subsidiary_company_id || ''
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }), company?.subsidiary_companies.map(c => {
    return /*#__PURE__*/React.createElement("option", {
      value: c.id
    }, c.name);
  })))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('project_category')), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    disabled: !pageAccess.canEditProjectDetails || report.assessment !== 'completed' || report.completion_status !== 'finished',
    as: "select",
    name: "category",
    onBlur: handleSubmit,
    onChange: handleChange,
    size: "md",
    value: report.category || 'tbc'
  }, /*#__PURE__*/React.createElement("option", {
    value: "rnd"
  }, t('r&d')), /*#__PURE__*/React.createElement("option", {
    value: "non_rnd"
  }, t('non_r&d')), /*#__PURE__*/React.createElement("option", {
    value: "tbc"
  }, t('tbc'))))), /*#__PURE__*/React.createElement(BusinessUnitsSection, {
    report: report,
    claimGroup: claimGroup,
    setReport: setReport,
    pageAccess: pageAccess
  }), /*#__PURE__*/React.createElement(ThemeSection, {
    report: report,
    claimGroup: claimGroup,
    setReport: setReport,
    pageAccess: pageAccess
  }), process.env.PUBLIC_URL !== '/ca' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('field_of_science_or_technology')), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewSelect, {
    disabled: !pageAccess.canEditProjectDetails,
    onBlur: handleSubmit,
    value: {
      value: report.field_of_science_and_technology,
      label: t(report.field_of_science_and_technology)
    },
    onChange: e => handleChange({
      target: {
        name: 'field_of_science_and_technology',
        value: e.value
      }
    }),
    options: sortByLabel(fields_of_science_and_technology.map(f => {
      return {
        value: f.value,
        label: t(f.value)
      };
    })),
    styles: {
      control: baseStyles => ({
        ...baseStyles,
        borderColor: '#80bbdc'
      })
    },
    filterOption: createFilter({
      matchFrom: 'start'
    })
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('total_cost')), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    disabled: !pageAccess.canEditProjectDetails,
    as: FormattedNumberInput,
    onChange: handleChange,
    onBlur: handleSubmit,
    name: "total_cost",
    object: report,
    size: "md",
    type: "text",
    min: 0
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('total_qe')), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    disabled: !pageAccess.canEditProjectDetails,
    as: FormattedNumberInput,
    onChange: handleChange,
    onBlur: handleSubmit,
    name: "total_qe",
    object: report,
    size: "md",
    type: "text",
    min: 0
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('r&d'), " %"), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    disabled: !pageAccess.canEditProjectDetails,
    as: Form.Control,
    onChange: handleChange,
    onBlur: handleSubmit,
    name: "total_fragments_rnd",
    object: report,
    size: "md",
    type: "number",
    max: 100,
    min: 0
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 4
  }, t('total_r&d_hours')), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    disabled: !pageAccess.canEditProjectDetails,
    as: FormattedNumberInput,
    decimalScale: 1,
    onChange: handleChange,
    onBlur: handleSubmit,
    name: "total_rnd_hours",
    object: report,
    size: "md",
    type: "text",
    min: 0
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: "8"
  }, /*#__PURE__*/React.createElement(InputGroup, null, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    as: "textarea",
    rows: "3",
    placeholder: t('type_a_comment'),
    value: comment,
    onChange: e => setComment(e.target.value)
  }), /*#__PURE__*/React.createElement(OverlayTrigger, {
    trigger: "click",
    placement: "right",
    show: showCommentPopup,
    rootClose: true,
    overlay: popover
  }, /*#__PURE__*/React.createElement(Button, {
    isImmutableUnderReview: true,
    variant: "primary",
    onClick: postComment,
    id: "button-addon2",
    disabled: false,
    className: "ms-1"
  }, t('save_a_new_comment'))))))));
};
export default SummarySection;